import "./tab-content.css.js";
const n = {
  modifiers: {
    secondary: "pf-m-secondary",
    padding: "pf-m-padding"
  },
  tabContent: "pf-v6-c-tab-content",
  tabContentBody: "pf-v6-c-tab-content__body"
};
export {
  n as default
};
